



$(document).ready(function () {
    function playSlider() {
        let prevBtn = $('.recently-viewed-container .slick-slider-wrapper .prevSlide');
        let nextBtn = $('.recently-viewed-container .slick-slider-wrapper .nextSlide');
        $('.recently-viewed').slick({
            slidesToShow: 4,
            infinite: true,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ],
        });
        prevBtn.css('display', 'block');
        nextBtn.css('display', 'block');
    }

    setTimeout(() => {
        let products_count = $(".recently-viewed li").length;
        if (products_count > 4) {
            playSlider();
        } else if (window.innerWidth < 990 && products_count > 2) {
            playSlider();
        }
    }, 1000);

    setTimeout(() => {
        $('.recently-viewed-container').css('display', 'block');
    }, 500);

    $(document).on('click', '.prevSlide', function () {
        $('.recently-viewed').slick('slickPrev');
    });

    $(document).on('click', '.nextSlide', function () {
        $('.recently-viewed').slick('slickNext');
    });
});